import { configureStore } from "./configureStore";

/**
 * Default app store instance.
 */
export default configureStore(undefined);
